import { EmptyArray } from "../domain/empty/model";
import { AccountingRepositoryImplementation } from '../infrastructure/accounting-repository-implementation';
import { Comprobante } from '../domain/accounting/model';


import { cacheManager } from '../infrastructure/cache-manager';

const repo = new AccountingRepositoryImplementation('', null);
const CACHE_PREFIX = 'accounting';

async function createComprobante(data: Record<string, unknown>) {
  const result = await repo.createComprobante(data).toPromise();
  cacheManager.invalidate(CACHE_PREFIX);
  return result;
}

async function getComprobante(id: number) {
  try {
    const cacheKey = `${CACHE_PREFIX}-comprobante-${id}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached) return cached;

    const result = await repo.getComprobante(id).toPromise();
    const data = result.data;
    if (!data || (Array.isArray(data) && data.length === 0)) return EmptyArray;

    cacheManager.setItem(cacheKey, data);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getComprobantes(page: number, limit: number, filters?: Record<string, unknown>) {
  try {
    const filterStr = filters ? JSON.stringify(filters) : '';
    const cacheKey = `${CACHE_PREFIX}-list-${page}-${limit}-${filterStr}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached) return cached;

    const result = await repo.getComprobantes(page, limit, filters).toPromise();
    const data = result;
    if (!data || (Array.isArray(data) && data.length === 0)) return EmptyArray;

    cacheManager.setItem(cacheKey, data);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getComprobantesById(id: number) {
  try {
    const result = await repo.getComprobantesById(id).toPromise();
    return result;
  } catch (error) {
    console.error(error);
  }
}

async function updateComprobante(id: number, data: Partial<Comprobante>) {
  try {
    const result = await repo.updateComprobante(id, data).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return result;
  } catch (error) {
    console.error(error);
  }
}

async function deleteComprobante(id: number) {
  try {
    await repo.deleteComprobante(id).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
  } catch (error) {
    console.error(error);
  }
}

async function getDocumentTypes() {
  const result = await repo.getDocumentTypes().toPromise();
  return result.data;
}

async function getClosingStatus(year: number) {
  const result = await repo.getClosingStatus(year).toPromise();
  return result.data;
}

async function calculateClosing(data: Record<string, unknown>) {
  const result = await repo.calculateClosing(data).toPromise();
  return result.data;
}

async function approveClosing(data: Record<string, unknown>) {
  const result = await repo.approveClosing(data).toPromise();
  return result.data;
}

async function getCostingStatus(year: number, month: number) {
  const result = await repo.getCostingStatus(year, month).toPromise();
  return result.data;
}

async function calculateCosting(data: Record<string, unknown>) {
  const result = await repo.calculateCosting(data).toPromise();
  return result.data;
}

async function approveCosting(data: Record<string, unknown>) {
  const result = await repo.approveCosting(data).toPromise();
  return result.data;
}

async function getTaxClosingStatus(year: number, month: number) {
  const result = await repo.getTaxClosingStatus(year, month).toPromise();
  return result.data;
}

async function calculateTaxClosing(data: Record<string, unknown>) {
  const result = await repo.calculateTaxClosing(data).toPromise();
  return result.data;
}

async function approveTaxClosing(data: Record<string, unknown>) {
  const result = await repo.approveTaxClosing(data).toPromise();
  return result.data;
}

export {
  createComprobante,
  getComprobante,
  getComprobantes,
  getComprobantesById,
  updateComprobante,
  deleteComprobante,
  getDocumentTypes,
  getClosingStatus,
  calculateClosing,
  approveClosing,
  getCostingStatus,
  calculateCosting,
  approveCosting,
  getTaxClosingStatus,
  calculateTaxClosing,
  approveTaxClosing,
};
